import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

export const initGA = (measurementId: string): void => {
    ReactGA.initialize(measurementId)
}

export const logPageView = (path: string): void => {
    ReactGA.send({ hitType: 'pageview', page: path })
}

export const RouteTracker = (): null => {
    const location = useLocation()

    useEffect(() => {
        logPageView(location.pathname)
    }, [location])

    return null
}
